<template>
  <div id="chart">
    <apexchart
      type="area"
      height="300"
      :options="chartOptions"
      :series="series"
      style="margin-top: 16px"
    />
  </div>
</template>
<script>
export default {
  name: 'AreaChart',
  props: {
    series: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: 'area',
          height: 350,
          zoom: {
            enabled: true
          },
          toolbar: {
            show: false
          }
        },
        colors: ['#082655', '#FF792E'],
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight',
          width: 2
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.3,
            stops: [0, 90, 100]
          }
        },
        xaxis: {
          type: 'datetime',
          labels: {
            format: 'MMM dd',
            datetimeUTC: false
          },
        },
        yaxis: {
          opposite: true,
          stepSize: 10
        },
        legend: {
          horizontalAlign: 'left',
          position: 'top'
        },
        tooltip: {
          x: {
            format: 'dd MMM yyyy'
          },
          custom: function ({seriesIndex, dataPointIndex, w}) {
            const point = w.config.series[seriesIndex].data[dataPointIndex];
            const dateLabel = point[0];
            const newValue = point[1];
            const total = point[2];
            const seriesName = w.config.series[seriesIndex].name;
            const color = w.globals.colors[seriesIndex] || '#082655';

            return (
              '<div class="apexcharts-tooltip-custom">' +
              `<div class="tooltip-title">${dateLabel}</div>` +
              '<div class="tooltip-row-wrapper">' +
              `<span class="marker" style="background:${color}"></span>` +
              '<div class="row-wrapper">' +
              '<div class="tooltip-row">' +
              `<span class="label">${seriesName}:</span>` +
              `<span class="value">${total}</span>` +
              '</div>' +
              '<div class="tooltip-row">' +
              '<span class="label">New:</span>' +
              `<span class="value">${newValue}</span>` +
              '</div>' +
              '</div>' +
              '</div>' +
              '</div>'
            );
          }
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5
          }
        }
      },
    };
  }
};
</script>

<style scoped>

</style>